import React, { Component } from 'react';
import * as axios from 'axios';
import PropTypes from 'prop-types';
import './njitProjectGrid.scss';
import map from 'lodash/map';

declare var jQuery: any;

class NjitProjectGrid extends Component {


  constructor(props) {
	  
    super(props);
	this.accessTypes=['Standard Access','Assisted Access','Staff Use Only','Submit a Job'];
    this.state = {
	    page:1,
	    perpage:12,
		data:{
			hits:{
				total:1,
				hits:[]
			}
		},
		categories:{
			buckets:[]	
		},
		filters:{
		    category:this.props.category,
		    access_level:[]
	    },
		loaded:false
    };
    this.updateCats = this.updateCats.bind(this);
    this.updateAccess = this.updateAccess.bind(this);
    this.setPage = this.setPage.bind(this);
    
  }
  
  componentDidMount() {
	if(1){
		let paramsBody= {filters:this.state.filters, page: this.state.page, perpage: this.state.perpage};
		
		axios({
			method: 'POST',
			url: this.props.endpoint,
			headers: {
			'Content-Type': 'application/json'
			},
			data: JSON.stringify(paramsBody)
	    }).then((response) => {
		    console.log("xhr returned");
		    console.log(response.data);
			this.setState({ data: response.data.responses[0], categories: response.data.responses[1].aggregations.categories, loaded: true})
	      	
	    })
	    .catch((error) => {

	    });    
/*		let paramsBody = {
	      'from': (this.props.data.from)? parseInt(this.props.data.from, 10): 0,
	      'size': (this.props.data.size)? parseInt(this.props.data.size, 10): 4,
	      'query': {
	        'query_string': {
	          'query': (this.props.data.query)? this.props.data.query: '*',
	        }
	      }
	    };
		axios({
			method: 'POST',
			url: '/search-api/njitmakerspace/equipment/_search',
			headers: {
			'Content-Type': 'application/json'
			},
			data: JSON.stringify(paramsBody)
	    }).then((response) => {
			this.setState({ data: response.data})
	      	console.log(this.state);
	    })
	    .catch((error) => {

	    });    
	    */
	   }
	}    
 getHref(href) {
    //console.log(typeof href, href)
    if(typeof href === 'string'){
      return href;
    } else {
      return '#';  
    }
    
  }
   espaceChars(text) {
    return text.replace(/"/g, '&quot;');
  }
  updateCats(event){
	var target = event.target;
  //  const value = target.type === 'checkbox' ? target.checked : target.value;
   // const name = target.name;
   var temp= this.state.filters.category;
   	if(target.checked){
   		temp.push(target.value);
   	}else{
	   	var index = temp.indexOf(target.value);
		if (index > -1) {
		  temp.splice(index, 1);
		}
   	}
	this.setState({filters:{category:temp, access_level:this.state.filters.access_level}});
	this.componentDidMount()
  }
  updateLevel(event){
  	var target = event.target;
  	var temp= this.state.filters.access_level;
  	console.log(this.state);
   	if(target.checked){
   		temp.push(target.value);
   	}else{
	   	var index = temp.indexOf(target.value);
		if (index > -1) {
		  temp.splice(index, 1);
		}
   	}
	this.setState({filters:{category: this.state.filters.category, access_level:temp}});
	this.componentDidMount()
  }
  updateAccess(event){
  	var target = event.target;
  	var temp= this.state.filters.access_level;
  	console.log(this.state);
   	if(target.checked){
   		temp.push(target.value);
   	}else{
	   	var index = temp.indexOf(target.value);
		if (index > -1) {
		  temp.splice(index, 1);
		}
   	}
	this.setState({filters:{category: this.state.filters.category, access_level:temp}});
	this.componentDidMount()
  }
  backgroundImage(url)
  {
	  return {
		  backgroundImage: 'url(' + url + ')',
	  }
  }

 
  setPage(event)
  {
	  console.log('input: '+event.target.id);
	  const page_num=event.target.id;
	  console.log("set page: "+page_num+"\ncurrent page: "+this.state.page);
	  if(page_num !== this.state.page){
	 	 this.setState({page:page_num});
	 	 console.log(this.state);
	 	 this.componentDidMount()
	  }
  }
  isSelected(value)
  {
	  return this.props.category.indexOf(value)>-1;
  }
  	render() {
	  	console.log("render called");
	  	console.log(this.props);
	  	var pages = Math.ceil(this.state.data.hits.total/12);
	  	const pageNumbers = [];
	    for (let i = 1; i <= pages; i++) {
	      pageNumbers.push(i);
	    }
	  	let output = this.state.data.hits.hits.map((d,i) => {
	  				var image = '';
	  				if(d._source.hasOwnProperty('image_square')){
	  					image = (<img className="picture" src={d._source.image_square} alt={d._source.title+  ' cover image'} />);
	  				}else{
	  					image = ('');
	  				}
	                return (<a key={i} href={this.getHref(d._source.base_url+d._source.alias)}>
	                    <div className="item">
	                       
	                           {image}
	                        
	                            <div className="item-title" >{d._source.title}</div>
								<div className="item-names">{d._source.team_members.value}</div>
	                            
	                        
	                    </div>
	                </a>)
	             } );
	  	
	  	if(!this.state.loaded)
	  	{
		  		return (
				<div className="equipment-wrapper">
		  
					<div className="filterbar">
						<div className="mobile-filter-trigger">Filters</div>
					</div>
					<div className="filters">
						<label>Categories</label>
						<div className="filterset">
						</div>
			        </div>
			        <div className="items">
						<div className="la-ball-grid-pulse">
							<div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						    <div></div>
						</div>
					</div>
				</div>
				); 
	  	}
	    return (
		  <div className="projectgrid-wrapper">
		  
		  	<div className="filterbar">
		  		<div className="mobile-filter-trigger">Filters</div>
		  	</div>
		  	  <div className="filters">
		  	  <label>Categories</label>
	          	<div className="filterset">
	          		
	          		<form>
	          		{this.state.categories.buckets.map((d,i) =>
		          		<div key={i}>
		          			<label>
		          				<input name="cat[]" type="checkbox" onChange={this.updateCats} value={d.key} checked={this.isSelected(d.key)} /> {d.key} ({d.doc_count}) 
		          			</label>
		          		</div>
	          		)}
	          		</form>
	          	</div>
	          
	          	          	
	          	
	          </div>

		      <div className="items">
	             {output}
	              
	          </div>
          </div>
	    );
  	}
}

/*
	
	<div className="pager"><ul>
	              	{pageNumbers.map(number =>
		              	<li
				          key={number}
				          id={number}
				          onClick={this.setPage}
				        >
				          {number}
				        </li>
		              	)}</ul>
	              </div>
	              */



NjitProjectGrid.propTypes = {
  category: PropTypes.array,

};

export default NjitProjectGrid;








// WEBPACK FOOTER //
// ./src/ProjectGrid/njitProjectGrid.js